"use client"

import { useRouter } from "next/navigation"

import { useState } from "react"
import { newPost } from "@/lib/api/notes"
import { Loader2, PlusCircle } from "lucide-react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { createNewPostClicked } from "../tracking"
import { getCoinsFlag } from "@/lib/utils/flags"

export default function NewPostButton(props: {
  blogSlug: string
  customDomain?: string
  source: string
  hideIcon?: boolean
  title?: string
  className?: string
  /**  If true, open the new post in a new tab */
  openInNewTab?: boolean
  /**
   * Minimal is no text, just the icon
   */
  variant?: "default" | "minimal"
}) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  const onClick = async () => {
    setLoading(true)

    createNewPostClicked(props.source)

    const postId = await newPost(props.blogSlug, {
      customDomain: props.customDomain,
      isCoined: getCoinsFlag(props.blogSlug, Date.now()),
    })

    if (props.openInNewTab) window.open(`/editor/${postId}`)
    else router.push(`/editor/${postId}`, {})

    setLoading(false)
  }

  return (
    <Button
      disabled={loading}
      onClick={onClick}
      className={cn(
        "self-center",
        props.variant === "minimal" && "pr-2",

        props.className
      )}
    >
      <>
        {loading ? (
          <Loader2
            className={cn(
              "mr-2 h-4 w-4 animate-spin",
              props.variant === "minimal" && "mr-0"
            )}
          />
        ) : (
          !props.hideIcon && (
            <PlusCircle
              className={cn(
                "mr-2 h-4 w-4",
                props.variant === "minimal" && "mr-0"
              )}
            />
          )
        )}
        {props.variant !== "minimal" && props.title ? props.title : "New post"}
      </>
    </Button>
  )
}
